
import jsPDFPendingPurchaseTemplate, { OutputType } from "./PendingPurchaseTemplate";
import currency from 'currency.js'


// Date Fns is used to format the dates we receive
// from our API call
import { parseISO, format } from 'date-fns';
import logo from '../../../assets/img/logo.jpg'; // Tell webpack this JS file uses this image


// define a generatePDF function that accepts a mainDatas argument
const generatePendingPurchasePrintPDF = (mainData, configData, parameters) => {

    const myDate = format(new Date(), 'dd/MM/yyyy')
    const dateFrom = format(new Date(parameters.date_from), 'dd/MM/yyyy')
    const dateTo = format(new Date(parameters.date_to), 'dd/MM/yyyy')
    const dataFrom = parameters.data_from === "" ? "0" : parameters.data_from
    const dataTo = parameters.data_to === "" ? "999999999" : parameters.data_to


    const currFormat = { decimal: ',', symbol: '', separator: '.' }
    var totalFact = 0;
    var totalCollected = 0;
    var totalDiff = 0;

    mainData.forEach(function (record) {
        totalFact += record.total;
        totalCollected += record.payed;
    });
    // totalDiff = totalFact - totalCollected;
    totalDiff = currency(totalFact-totalCollected, currFormat).format()
    totalFact = currency(totalFact, currFormat).format()
    totalCollected = currency(totalCollected, currFormat).format()
    // console.log(totalDiff)


    var arrLines = Array.from(mainData, (item, index) => ([
        index + 1,
        format(new Date(item.date+ 'T23:59:59.999Z'), 'dd/MM/yyyy'),
        item.invoice,
        format(new Date(item.due_date+ 'T23:59:59.999Z'), 'dd/MM/yyyy'),
        item.provider.name,
        currency(item.total, currFormat).format(),
        currency(item.payed, currFormat).format()

    ]))

    
    arrLines = [...arrLines,
    [{
        content: `Total Adeudado: ${totalFact}`, colSpan: 3,
        styles: { fillColor: [220,220,220],
            textColor: [0,0,0]}
    },
    {
        content: `Total Pagado: ${totalCollected}`, colSpan: 2,
        styles: { fillColor: [220,220,220],
            textColor: [0,0,0] }
    },    
    {content: `Total por pagar: ${totalDiff}`, colSpan: 2, 
      styles: { fillColor: [220,220,220],
        textColor: [0,0,0] }
    }    
    ]]

    var props = {
        outputType: 'blob',
        returnJsPDFDocObject: true,
        fileName: `pending-invoices-report-${new Date()}`,
        orientationLandscape: false,
        logo: {
            src: logo,
            width: 30.33, //aspect ratio = width/height
            height: 26.66,
            margin: {
                top: 0, //negative or positive num, from the current position
                left: 0 //negative or positive num, from the current position
            }
        },
        business: {
            name: configData.company_name,
            address: `${configData.company_address1} - ${configData.company_address2}`,
            phone: configData.company_phone,
            email: configData.company_email,
            email_1: configData.company_email1,
            website: configData.company_web_url,
            date: myDate
        },
        invoice: {
            label: `Facturas por Pagar`,
            label2: `todas las facturas`,
            label3: ``,
            headerBorder: true,
            tableBodyBorder: true,
            header: ["#", "Fecha", "Numero", "Vencimiento", "Cliente", "Total", "Cobrado"],
            table: arrLines,
            invTotalLabel: "Por Pagar:",
            invTotal: totalDiff,
            InvTotalCost: 0,
            InvTotalPrice: 0,
            invCurrency: "$",
            row1: {

            },
            row2: {
                col1: "Total Pagado",
                col2: totalCollected,
                col3: "$"

            },
            row3: {
                col1: "Total Adeudado",
                col2: totalFact,
                col3: "$"

            },
            invDescLabel: "",
            invDesc: "",
        },
        footer: {
            text: "",
        },
        pageEnable: true,
        pageLabel: "Page ",
    };
    const pdfCreated = jsPDFPendingPurchaseTemplate(props); //returns number of pages created
    var blob = pdfCreated.blob;

    var pdfObject = pdfCreated.jsPDFDocObject;


    window.open(URL.createObjectURL(pdfObject.output("blob")))

    // pdfCreated.jsPDFDocObject.output("blob"); //or .output('<outputTypeHere>');

};

export default generatePendingPurchasePrintPDF;